import { Loader } from 'kiswe-ui'
import { FanRoomScheduleConfigBase } from './FanRoomScheduleConfigBase'
import { FanRoomScheduleProcessState } from '../types'

export class FanRoomScheduleConfigManual extends FanRoomScheduleConfigBase {
  ended_at: Date|null = null
  error: string|null = null
  requested_at: Date
  requested_by: string
  started_at: Date|null = null
  state: FanRoomScheduleProcessState


  constructor (data: unknown) {
    super(data)
    this.ended_at = Loader.loadDateOrNull(data, 'ended_at', this.ended_at)
    this.error = Loader.loadStringOrNull(data, 'error', this.error)
    this.requested_at = Loader.loadDate(data, 'requested_at')
    this.requested_by = Loader.loadString(data, 'requested_by')
    this.started_at = Loader.loadDateOrNull(data, 'started_at', this.started_at)
    this.state = Loader.loadEnum(
      data, 'state', FanRoomScheduleProcessState.Pending, Object.values(FanRoomScheduleProcessState)
    )
  }
}
